import LoginFormView from './LoginFormView';
import { useGetAllBranches } from '@/shared/api/client/company-resource';
import { useGetVersion } from '@/shared/api/client/version-controller';
// TODO: Update these imports when assets are migrated
// import companyLogo from '../../../assets/images/login.png';

const LoginView = () => {
    const { data: branches, isLoading, isError, error } = useGetAllBranches({
        query: {
            staleTime: 5 * 60 * 1000, // Cache for 5 minutes
            refetchOnWindowFocus: false,
        }
    });
    const { data: versionData } = useGetVersion();

    // Get company data from the first branch (assuming all branches belong to same company)
    const data = branches && branches.length > 0 ? {
        brFname: branches[0].branchName || 'ScaleFi Essence',
        brsesDate: new Date().toLocaleDateString()
    } : null;

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        console.error("Error in useCompany:", error);
        return <div>Something went wrong: {(error as Error)?.message}</div>;
    }

    if (!data) {
        return <div>No company data available.</div>;
    }

    const { brFname, brsesDate } = data;

    return (
        <div className="h-screen flex items-center">
            {/*@ts-ignore*/}
            <style jsx={"true"}>{`
                .animate-gradient {
                    @keyframes animating-background {
                        0% {
                            background-position: 0% 50%;
                        }
                        100% {
                            background-position: 100% 50%;
                        }
                    }
                }
            `}</style>
            <div className="w-full mx-auto flex flex-wrap md:flex-no-wrap">
                {/* Left Column - Company Name and Session Date */}
                <div className="animate-gradient bg-gradient-to-r from-gray-500 via-gray-550 to-gray-600 animate-gradient h-screen hidden w-full md:w-4/6 py-4 md:py-0 md:flex flex-col justify-center items-center md:items-start">
                    <div className="flex flex-col justify-center items-center w-full mb-28">
                        {/* TODO: Add company logo when assets are migrated */}
                        <div className="w-32 h-32 bg-gray-300 rounded-lg flex items-center justify-center">
                            <span className="text-gray-600">Logo</span>
                        </div>
                    </div>
                    <div className="flex flex-col justify-center items-center w-full mb-72">
                        <h1 className="text-gray-100 text-3xl mb-4 font-sans">{brFname}</h1>
                        <p className="text-white font-sans">Session Date: {brsesDate}</p>
                    </div>
                </div>

                {/* Right Column - Login Form */}
                <div className="bg-gray-50 h-screen w-full md:w-2/6 flex flex-col justify-center items-center">
                    <LoginFormView />
                    <div style={{ fontSize: 11, opacity: 0.5, marginTop: 16, textAlign: 'center' }}>
                        <span>v{versionData?.version || 'dev-local'} &mdash; Powered by </span>
                        <a href={versionData?.website || 'https://scalefi.co.tz'} target="_blank" rel="noopener noreferrer"
                           style={{ color: 'inherit', textDecoration: 'underline' }}>
                            {versionData?.poweredBy || 'ScaleFi'}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginView;